import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const INIT_STATE = {
  filter: {
    search: "",
    receive_branch_code: "",
    start_date: moment().add(-1, "months"),
    end_date: moment(),
    page: 1,
    limit: 10,
  },
};

const storeQrTrackingSlice = createSlice({
  name: "tracking",
  initialState: INIT_STATE,
  reducers: {
    CLEAR: (state) => {
      state.filter = { ...INIT_STATE.filter };
    },
    SET_FILTER: (state, { payload }) => {
      state.filter = { ...state.filter, ...payload };
    },
  },
});

export const actionStoreQrTracking = storeQrTrackingSlice.actions;

export const filterSelector = (state) => state.storeQR.tracking.filter;

const StoreQrTrackingReducer = storeQrTrackingSlice.reducer;

export default StoreQrTrackingReducer;
